export interface Bonus {
  id: string
  title: string
  subtitle: string
  lead?: string
  listLabel: string
  items: string[]
  flow?: boolean
  progressionLabel?: string
  progression?: string
  closing: string[]
  badgeClass: string
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: '100 Makeup Student Mistakes & Instructor Corrections',
    subtitle:
      'A Visual Troubleshooting Guide for Identifying, Explaining & Correcting Common Makeup Errors',
    lead: 'Quickly identify common student problems and know how to respond.',
    listLabel: 'Each mistake follows a practical teaching system:',
    items: [
      'Student Error',
      'What You See',
      'Why It Happens',
      'How to Correct It',
      'Instructor Cue',
      'Student Retry',
    ],
    flow: true,
    closing: [
      'Stop giving vague corrections.',
      'Show students exactly what needs to change.',
    ],
    badgeClass: 'bg-rose-700 text-white',
  },
  {
    id: '02',
    title: 'Makeup Technique Demonstration Guide',
    subtitle:
      'How to Demonstrate Makeup Techniques Clearly, Step by Step, in Front of Students',
    listLabel: 'Know:',
    items: [
      'What to explain',
      'What to demonstrate',
      'Where to pause',
      'What students should watch',
      'What questions to ask',
      'What mistake to anticipate',
      'How to move from observation into practice',
    ],
    closing: ['Show why — not only how.'],
    badgeClass: 'bg-rose-600 text-white',
  },
  {
    id: '03',
    title: 'Student Assessment & Skill Progression System',
    subtitle:
      'Professional Rubrics, Practical Assessments & Skill Levels for Makeup Students',
    listLabel: 'Evaluate:',
    items: [
      'Hygiene',
      'Complexion',
      'Brows',
      'Eyes',
      'Blending',
      'Liner',
      'Lashes',
      'Lips',
      'Symmetry',
      'Color harmony',
      'Complete looks',
      'Timing',
      'Professional decision-making',
    ],
    progressionLabel: 'Use a clear progression:',
    progression: 'Foundational → Developing → Functional → Advanced',
    closing: [
      'Know what your student can do now — and what they need to improve next.',
    ],
    badgeClass: 'bg-stone-100 text-rose-900 border border-stone-200',
  },
  {
    id: '04',
    title: '50 Makeup Practice Labs & Classroom Activities',
    subtitle:
      'Ready-to-Run Exercises for Technique, Precision, Color, Blending, Symmetry & Complete Look Development',
    listLabel: 'Fifty practical activities for:',
    items: [
      'Foundation matching',
      'Skin preparation',
      'Color correction',
      'Brow mapping',
      'Blending',
      'Eyeliner',
      'Lashes',
      'Lip precision',
      'Face balance',
      'Soft Glam',
      'Complete looks',
      'Timed challenges',
      'Troubleshooting',
    ],
    closing: ['Demo. Practice. Observe. Correct. Repeat.'],
    badgeClass: 'bg-stone-800 text-white',
  },
  {
    id: '05',
    title: 'Makeup Instructor Class Planning & Teaching Toolkit',
    subtitle:
      'Ready Class Structures, Teaching Frameworks & Adaptations for Private Students, Groups & Beauty Academies',
    listLabel: 'Organize:',
    items: [
      '45-minute lessons',
      '60-minute lessons',
      '90-minute lessons',
      '120-minute lessons',
      'Private students',
      'Small groups',
      'Large classes',
      'Beginner students',
      'Developing students',
      'Advanced students',
      'Technique lessons',
      'Complete-look lessons',
      'Assessment classes',
    ],
    closing: [
      'Choose the time, level and teaching goal — then follow the structure.',
    ],
    badgeClass: 'bg-rose-900 text-white',
  },
]
